(function () {
  var root = document.querySelector(".or-page");
  if (!root) return;

  (function lockMobileHero() {
    var hero = root.querySelector(".or-hero");
    var photo = root.querySelector(".or-hero__photo");
    if (!hero) return;
    var narrow = window.matchMedia("(max-width: 749px)");
    var lockedWidth = 0;

    function apply(force) {
      if (!narrow.matches) {
        document.documentElement.style.removeProperty("--or-hero-lock");
        lockedWidth = 0;
        return;
      }
      var width = window.innerWidth;
      if (!force && lockedWidth && Math.abs(width - lockedWidth) < 48) return;
      var height = Math.round(window.innerHeight - 16);
      if (height < 1) return;
      document.documentElement.style.setProperty("--or-hero-lock", height + "px");
      lockedWidth = width;
      if (photo) photo.style.transform = "none";
    }

    apply(true);
    window.addEventListener("resize", function () { apply(false); });
    window.addEventListener("orientationchange", function () {
      window.setTimeout(function () { apply(true); }, 350);
    });
  })();

  function startVids() {
    root.querySelectorAll("video[data-capsule]").forEach(function (video) {
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;
      var pending = video.play();
      if (pending && pending.catch) pending.catch(function () {});
    });
  }

  setTimeout(startVids, 50);

  if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  var frame = 0;
  var rows = Array.prototype.slice.call(root.querySelectorAll("[data-gal-row]"));
  var groups = Array.prototype.slice.call(root.querySelectorAll("[data-parallax-group]"));

  rows.forEach(function (row) {
    row._dir = +row.getAttribute("data-gal-row") || 1;
  });

  function measure() {
    var y = window.scrollY;
    rows.forEach(function (row) {
      var box = row.getBoundingClientRect();
      row._top = box.top + y;
      row._h = box.height;
      row._w = row.parentElement.getBoundingClientRect().width;
    });
    groups.forEach(function (group) {
      var box = group.getBoundingClientRect();
      group._top = box.top + y;
      group._h = box.height;
    });
  }

  var shown = [];
  var lastTime = 0;

  function rowTarget(row, y, vh) {
    var top = row._top - y;
    var progress = Math.max(-0.5, Math.min(0.5, (vh - top) / (vh + row._h) - 0.5));
    return progress * 2 * 0.055 * row._w * row._dir;
  }

  function tick(now) {
    var vh = window.innerHeight;
    var y = window.scrollY;
    var dt = lastTime ? Math.min(34, now - lastTime) : 16;
    lastTime = now;
    var follow = 1 - Math.exp(-dt / 90);
    var pending = false;

    groups.forEach(function (group) {
      var top = group._top - y;
      var offset = (top + group._h / 2 - vh / 2) * -0.07;
      var shift = "translate3d(0," + offset.toFixed(2) + "px,0)";
      group.querySelectorAll("[data-parallax]").forEach(function (el) {
        if (el._shift !== shift) {
          el._shift = shift;
          el.style.transform = shift;
        }
      });
    });

    rows.forEach(function (row, i) {
      var target = rowTarget(row, y, vh);
      if (shown[i] == null) shown[i] = target;
      var next = shown[i] + (target - shown[i]) * follow;
      if (Math.abs(target - next) < 0.04) next = target;
      else pending = true;
      shown[i] = next;
      var shift = "translate3d(" + next.toFixed(2) + "px,0,0)";
      if (row._shift !== shift) {
        row._shift = shift;
        row.style.transform = shift;
      }
    });

    frame = pending ? window.requestAnimationFrame(tick) : 0;
    if (!pending) lastTime = 0;
  }

  function onScroll() {
    if (!frame) frame = window.requestAnimationFrame(tick);
  }

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", function () {
    measure();
    onScroll();
  });
  measure();
  tick(0);
  window.addEventListener("load", function () {
    measure();
    onScroll();
  });

  root.querySelectorAll("[data-reveal]").forEach(function (el) {
    if (!el.querySelector(":scope > h2, :scope > p")) return;
    el.removeAttribute("data-reveal");
    Array.prototype.forEach.call(el.children, function (child) {
      if (window.getComputedStyle(child).position !== "absolute") {
        child.setAttribute("data-reveal", child.tagName === "H2" ? "titre" : "1");
      }
    });
  });

  var observer = new IntersectionObserver(function (entries) {
    var seen = 0;
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      var delay = seen++ * 90;
      entry.target.animate(
        [
          { opacity: 0, transform: "translate3d(0,14px,0)" },
          { opacity: 1, transform: "none" }
        ],
        { duration: 1400, delay: delay, easing: "cubic-bezier(.25,.1,.25,1)", fill: "backwards" }
      );
      entry.target.style.opacity = "";
    });
  }, { threshold: 0.2, rootMargin: "0px 0px -8% 0px" });

  root.querySelectorAll("[data-reveal]").forEach(function (el) {
    if (el.getBoundingClientRect().top > window.innerHeight * 0.92) el.style.opacity = "0";
  });

  window.setTimeout(function () {
    root.querySelectorAll("[data-reveal]").forEach(function (el) {
      observer.observe(el);
    });
  }, 60);
})();
